export const RECENT_TRANSCRIPTS_PAGE_SIZE = 20;

export interface AiWriterViewProps {
  isOpenedInPopOver: boolean;
  isAiWriterDropdownOpen: boolean;
  onBack(): void;
  onClose(): void;
  onContentSelected(text: string): void;
}
